import { AxiosResponse } from 'axios';
import { format } from 'date-fns';
import { usage } from '@saucelabs/sl-util-axios';

import { API_DATE_FORMAT } from '../../constants';

export const fetchMonthlyUsage = (
  endDate: Date,
  periods: number,
): Promise<AxiosResponse<MonthlyBurnResponse>> => (
  usage.get<MonthlyBurnResponse>(
    '/organization/credits_burn/monthly',
    {
      params: {
        last_billing_date: format(endDate, API_DATE_FORMAT),
        periods,
      },
    },
  )
);
